(function(window, document) {
    var nodeTypeElement = document.querySelector('.twitter-timeline-nodetype');
    if (nodeTypeElement !== null) {
        var clickElement = document.querySelector('.twitter-timeline-nodetype .twitter-timeline-nodetype--overlay');

        clickElement.addEventListener('click', function() {
            var scriptElement = document.querySelector('.twitter-timeline-nodetype [data-src]');
            scriptElement.setAttribute('src', scriptElement.getAttribute('data-src'));
            clickElement.remove();
        });

    }
})(window, document);

